// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Slot = { slotId: string; measureId?: string };
export type Board = { id: string; name: string };

export type PersistedState = {
  boards: Board[];
  activeBoardId: string;
  slotsByBoardId: Record<string, Slot[]>;
};

const makeDefaultSlots = (): Slot[] =>
  Array.from({ length: 6 }, (_, i) => ({ slotId: `slot-${i}`, measureId: undefined }));

const defaultPersisted: PersistedState = {
  boards: [{ id: "board-1", name: "Statistics" }],
  activeBoardId: "board-1",
  slotsByBoardId: { "board-1": makeDefaultSlots() },
};

export interface MultiboardState {
  saved: PersistedState; 
}

const initialState: MultiboardState = {
  saved: defaultPersisted,
};

const multiboardSlice = createSlice({
  name: "multiboard",
  initialState,
  reducers: {
    setSaved(state, action: PayloadAction<PersistedState>) {
      state.saved = action.payload;
    },
  },
});

export const { setSaved } = multiboardSlice.actions;
export default multiboardSlice.reducer;